module.exports = __webpack_public_path__ + "8b52c732099760e10a63bb7393f78488.png";